import React, { useState } from "react";

const REQUIREMENTS = [
  { label: "At least 8 characters", test: (p) => p.length >= 8 },
  { label: "One uppercase letter", test: (p) => /[A-Z]/.test(p) },
  { label: "One lowercase letter", test: (p) => /[a-z]/.test(p) },
  { label: "One number", test: (p) => /\d/.test(p) },
  { label: "One special character", test: (p) => /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(p) },
];

function PasswordStrengthBar({ password }) {
  const [showReqs, setShowReqs] = useState(false);
  const passed = REQUIREMENTS.filter((r) => r.test(password)).length;
  const strength = password ? Math.round((passed / REQUIREMENTS.length) * 100) : 0;

  const barColor =
    strength === 0 ? "#e2e8f0" :
    strength <= 40 ? "#dc2626" :
    strength <= 60 ? "#f59e0b" :
    strength <= 80 ? "#06b6d4" :
    "#059669";

  const label =
    strength === 0 ? "" :
    strength <= 40 ? "Weak" :
    strength <= 60 ? "Fair" :
    strength <= 80 ? "Good" :
    "Strong";

  return (
    <div
      className="AdminPwBarWrap"
      onMouseEnter={() => setShowReqs(true)}
      onMouseLeave={() => setShowReqs(false)}
    >
      <div className="AdminPwBar">
        <div className="AdminPwBarFill" style={{ width: `${strength}%`, background: barColor }} />
      </div>
      {password && <span className="AdminPwBarLabel" style={{ color: barColor }}>{label}</span>}
      {showReqs && (
        <div className="AdminPwReqs">
          {REQUIREMENTS.map((r, i) => (
            <div key={i} className={`AdminPwReq ${r.test(password) ? "AdminPwReqMet" : ""}`}>
              {r.test(password) ? "✓" : "○"} {r.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default PasswordStrengthBar;
